"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskWatchHandler = void 0;
const react_hooks_1 = require("@apollo/react-hooks");
const TaskModel_1 = __importDefault(require("@opsbase/lib-data-model/models/TaskModel"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const TaskStatus_1 = __importDefault(require("@opsbase/lib-task/TaskStatus"));
const useInterval_1 = __importDefault(require("@opsbase/react-hooks/useInterval"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const TimelapseIcon_1 = __importDefault(require("@opsbase/web-icons/icons/TimelapseIcon"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const IconButton_1 = __importDefault(require("@opsbase/web-ui/IconButton"));
const NonModalPopover_1 = __importDefault(require("@opsbase/web-ui/NonModalPopover"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
const useTaskWatcher_1 = __importDefault(require("../useTaskWatcher"));
const useTaskWatcherActions_1 = __importDefault(require("../useTaskWatcherActions"));
const TaskWatchItem_1 = __importDefault(require("./TaskWatchItem"));
const makeMyClasses = () => ({
    badge: {
        position: 'absolute',
        color: lib_palette_1.default.White.main,
        borderRadius: 10,
        height: 16,
        width: 16,
        fontSize: 12,
        lineHeight: '16px',
        textAlign: 'center',
    },
    processing: {
        top: 0,
        left: 0,
        backgroundColor: lib_palette_1.default.progress.main,
    },
    failed: {
        top: 0,
        right: 0,
        backgroundColor: lib_palette_1.default.error.main,
    },
    success: {
        bottom: 0,
        right: 0,
        backgroundColor: lib_palette_1.default.positive.main,
    },
    message: {
        position: 'relative',
        display: 'inline-block',
        float: 'left',
        color: lib_palette_1.default.White.main,
        borderRadius: 10,
        fontSize: 12,
        lineHeight: '16px',
        zIndex: 2001,
        padding: 8,
        left: 16,
        top: 0,
        backgroundColor: lib_palette_1.default.progress.main,
    },
    button: {
        position: 'relative',
        padding: '0 8px',
        display: 'inline-block',
    },
    popover: {
        padding: 16,
    },
});
const gqlStr = (0, graphql_tag_1.default) `
	query tasks($id: [String]) {
		tasks(id: $id) {
			items {
				id
				title
				type
				status
				config
				log
				response
				createdDate
				startedDate
				completedDate
			}
		}
	}
`;
function TaskWatchHandler() {
    const watchedTasks = (0, useTaskWatcher_1.default)();
    const { stopWatchingTasks } = (0, useTaskWatcherActions_1.default)();
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const [anchorEl, setAnchorEl] = (0, react_1.useState)();
    const [tasks, setTasks] = (0, react_1.useState)([]);
    // Have we got new tasks that we're watching
    // I.e. are there any that were created in the last 4 seconds
    const hasNew = watchedTasks.some(t => (0, moment_timezone_1.default)().diff((0, moment_timezone_1.default)(t.createdDate), 'seconds') < 4);
    // Query all tasks (that we aren't yet finished)
    const { data, refetch } = (0, react_hooks_1.useQuery)(gqlStr, {
        variables: { id: watchedTasks.map(t => t.id) },
        skip: watchedTasks.length === 0,
        fetchPolicy: 'network-only',
    });
    // If the data has changed, set it to our state
    react_1.default.useEffect(() => {
        const loadedTasks = ((data === null || data === void 0 ? void 0 : data.tasks) ? data.tasks.items : []).map(t => new TaskModel_1.default(t));
        loadedTasks.forEach(t => {
            if (t.isFinished)
                stopWatchingTasks([t]);
        });
        setTasks([
            ...tasks.filter(t => !loadedTasks.find(tt => tt.id === t.id)),
            ...loadedTasks,
        ]);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data]);
    // Tick
    (0, useInterval_1.default)(() => refetch(), watchedTasks.length > 0 ? 3000 : null);
    // Tasks Counts
    const noProcessing = tasks.filter(t => !t.isFinished).length;
    const noFailed = tasks.filter(t => t.status === TaskStatus_1.default.FAILURE).length;
    const noSuccess = tasks.filter(t => t.status === TaskStatus_1.default.SUCCESS).length;
    // Event Handlers
    const handleOpenMenu = (0, react_1.useCallback)(e => {
        setAnchorEl(e.currentTarget);
    }, []);
    const handleCloseMenu = (0, react_1.useCallback)(() => {
        setAnchorEl(undefined);
    }, []);
    const handleCloseTask = (0, react_1.useCallback)(task => {
        const newTasks = [...tasks.filter(t => t.id !== task.id)];
        setTasks(newTasks);
        if (newTasks.length === 0)
            setAnchorEl(undefined);
    }, [tasks]);
    // Render
    return tasks.length ? (react_1.default.createElement(react_1.default.Fragment, null,
        hasNew && react_1.default.createElement("div", { className: myCss.message }, "Job added to queue"),
        react_1.default.createElement("div", { className: myCss.button, style: { zIndex: hasNew ? 2000 : 0 } },
            react_1.default.createElement(IconButton_1.default, { size: 32, round: true, icon: react_1.default.createElement(TimelapseIcon_1.default, { color: lib_palette_1.default.GreyBlue, size: 32 }), onClick: handleOpenMenu }),
            noProcessing > 0 && (react_1.default.createElement("div", { className: myCss.badge + ' ' + myCss.processing }, noProcessing)),
            noFailed > 0 && react_1.default.createElement("div", { className: myCss.badge + ' ' + myCss.failed }, noFailed),
            noSuccess > 0 && (react_1.default.createElement("div", { className: myCss.badge + ' ' + myCss.success }, noSuccess))),
        react_1.default.createElement(NonModalPopover_1.default, { classes: { paper: myCss.popover }, open: !!anchorEl, anchorEl: anchorEl, onClose: handleCloseMenu },
            react_1.default.createElement(Vertical_1.default, { gutter: true }, tasks.map(task => (react_1.default.createElement(TaskWatchItem_1.default, { key: task.id, task: task, onClose: handleCloseTask }))))))) : null;
}
exports.TaskWatchHandler = TaskWatchHandler;
exports.default = TaskWatchHandler;
